import { TenantRole } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useInvalidateInvitedUserListQuery } from "@/queries/query-user-invited";

interface InviteUserProps {
  email: string;
  role: TenantRole;
}

export function useInviteUserToTenant() {
  const invalidateInvitedUsersQuery = useInvalidateInvitedUserListQuery();
  return useMutationWithErrorHandler(async ({ email, role }: InviteUserProps) => {
    const response = await getRanaApiV1().InvitationsApi.invitationCreate({
      invitationCreate: {
        email,
        tenantRole: role,
        project: null,
        projectRole: null,
      },
    });

    invalidateInvitedUsersQuery();

    return getRanaApiV1().InvitationsApi.invitationSendEmail({ invitationId: response.id });
  });
}
